import { useState } from "react";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import People from "./People";
import Bots from "./Bots";
import { tabbedDataGridPage } from "../../styles/commonPageStyles";
import { useNotification } from "../../components/Notification";
import ConfirmationDialog from "../../components/ConfirmationDialog";
import { useHasPermission } from "../../api/iam";

// The tab chain is stretched to the viewport so the grid inside a panel can
// claim whatever height is left below the tab list, matching the control
// planes / clusters pages.
const fillHeight = {
  mainBox: {
    ...tabbedDataGridPage.mainBox,
    height: "100vh",
    display: "flex",
    flexDirection: "column",
  },
  tabContainer: {
    ...tabbedDataGridPage.tabContainer,
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
  },
  tabPanel: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    paddingLeft: "4px",
    // `display: flex` above would override the browser's [hidden] rule and
    // make the inactive panel claim flex space — keep it collapsed.
    "&[hidden]": { display: "none" },
  },
};

const Users = () => {
  const [selectedTab, setSelectedTab] = useState("People");

  const [confirmationDialog, setConfirmationDialog] = useState({
    isOpen: false,
    title: "",
    content: "",
    handleDialogConfirm: () => {},
  });

  const resetDialog = () => {
    setConfirmationDialog({
      isOpen: false,
      title: "",
      content: "",
      handleDialogConfirm: () => {},
    });
  };

  const { notificationComponent, displayNotification } = useNotification();

  const tabs = [
    useHasPermission("/user-management/users", "GET", "LIST_PEOPLE") && {
      value: "People",
      component: (
        <People
          displayNotification={displayNotification}
          setConfirmationDialog={setConfirmationDialog}
        />
      ),
    },
    useHasPermission("/user-management/users", "GET", "LIST_BOTS") && {
      value: "Bots",
      component: (
        <Bots
          displayNotification={displayNotification}
          setConfirmationDialog={setConfirmationDialog}
        />
      ),
    },
  ].filter(Boolean);

  return (
    <Box sx={fillHeight.mainBox}>
      {notificationComponent}
      <ConfirmationDialog
        isOpen={confirmationDialog.isOpen}
        title={confirmationDialog.title}
        handleDialogConfirm={confirmationDialog.handleDialogConfirm}
        content={confirmationDialog.content}
        resetDialog={resetDialog}
      />
      <Box sx={fillHeight.tabContainer}>
        <TabContext value={selectedTab}>
          <Box sx={tabbedDataGridPage.tabListBox}>
            <TabList
              onChange={(e, newValue) => setSelectedTab(newValue)}
              sx={tabbedDataGridPage.tabList}
            >
              {tabs.map((tab, i) => (
                <Tab
                  key={i}
                  label={tab.value}
                  value={tab.value}
                  icon={<></>}
                  iconPosition="end"
                />
              ))}
            </TabList>
          </Box>
          {tabs.map((tab, i) => (
            <TabPanel key={i} value={tab.value} sx={fillHeight.tabPanel}>
              {tab.component}
            </TabPanel>
          ))}
        </TabContext>
      </Box>
    </Box>
  );
};

export default Users;
